import React from 'react'

import { getProjectId } from '../session/sessionStorage'
import { hasValue } from './value'

const BASE = '_BTIME_LS_'

const genKey = key => {
  const project = getProjectId()
  if (!project) return BASE + key
  return `${BASE}PROJECT_${project}_${key}`
}

export const setLocalStorageItem = (key, value) => {
  return localStorage.setItem(genKey(key), JSON.stringify(value))
}

export const getLocalStorageItem = key => {
  const value = localStorage.getItem(genKey(key))
  if (value === 'undefined') return undefined
  return JSON.parse(value)
}

export const removeLocalStorageItem = key => {
  return localStorage.removeItem(genKey(key))
}

export const clearLocalStorage = () => {
  return localStorage.clear()
}

export const useLocalStorageWatcher = (key, value, condition) => {
  React.useEffect(() => {
    if (!hasValue(condition) || !!condition) {
      setLocalStorageItem(key, value)
    }
  }, [value])
}
